export default [
  {
    path: '/landing/bankeys',
    name: 'buyBankeys',
    component: () => import('../views/bankeys/Index.vue'),
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('../views/bankeys/Home.vue'),
      },
      {
        path: 'download',
        name: 'download',
        component: () => import('../views/bankeys/Download.vue'),
      },
      {
        path: 'result',
        name: 'bankeysResult',
        component: () => import('../views/bankeys/Result.vue'),
      },
    ],
  },
]
